import { ReferralVideo } from './ReferralVideo';
import { Image, Link } from '../../snippets';

export function ReferralMedia({ aboveTheFold, media, videoAlt, firstButton }) {
  const { image, video } = { ...media };
  const firstButtonUrl = firstButton?.url;

  const MediaWrapper = ({ children, className }) => {
    return firstButtonUrl ? (
      <Link
        aria-label={
          firstButton?.newTab ? `Open in a new tab to view ${firstButton?.link?.text}` : firstButton?.link?.text
        }
        href={firstButtonUrl}
        newTab={firstButton?.newTab}
        type={firstButton?.type}
        className={className}
      >
        {children}
      </Link>
    ) : (
      <div className={className}>
        {children}
      </div>
    );
  };

  return (
    <div className="absolute inset-0 h-full w-full">
      <MediaWrapper className="relative block h-full w-full overflow-hidden md:hidden">
        {video?.srcMobile && (
          <ReferralVideo
            autoplay={video.autoplay}
            posterSrc={video.posterMobile?.src}
            sound={video.sound}
            videoAlt={videoAlt}
            videoSrc={video.srcMobile}
          />
        )}

        {image?.imageMobile?.src && !video?.srcMobile && (
          <Image
            alt={image.alt}
            className={`${image.positionMobile}`}
            fill
            sizes="100vw"
            priority={aboveTheFold}
            src={image.imageMobile.src}
          />
        )}
      </MediaWrapper>

      <MediaWrapper className="relative hidden h-full w-full overflow-hidden md:block">
        {video?.srcDesktop && (
          <ReferralVideo
            autoplay={video.autoplay}
            posterSrc={video.posterDesktop?.src}
            sound={video.sound}
            videoAlt={videoAlt}
            videoSrc={video.srcDesktop}
          />
        )}

        {image?.imageDesktop?.src && !video?.srcDesktop && (
          <Image
            alt={image.alt}
            className={`${image.positionDesktop}`}
            fill
            priority={aboveTheFold}
            sizes="50vw"
            src={image.imageDesktop.src}
          />
        )}
      </MediaWrapper>
    </div>
  );
}

ReferralMedia.displayName = 'ReferralMedia';
